import { render, staticRenderFns } from "./DashboardForm.vue?vue&type=template&id=89eb90d4&scoped=true"
import script from "./DashboardForm.vue?vue&type=script&lang=js"
export * from "./DashboardForm.vue?vue&type=script&lang=js"
import style0 from "./DashboardForm.vue?vue&type=style&index=0&id=89eb90d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89eb90d4",
  null
  
)

export default component.exports